<p-table [showGridlines]="true"
  [value]="searchResult?.Result"
  [paginator]="true"
  [rows]="searchParams ? searchParams.PageSize : 20"
  [totalRecords]="searchResult?.TotalCount"
  (onLazyLoad)="lazyLoad($event)"
  [lazy]="true"
  [loading]="loading"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <p-button
      icon="pi pi-sort-alt"
      [rounded]="true"
      [text]="true"
      *ngIf="sortOrder === 0"
      aria-hidden="true"
      styleClass="wl-prime-datatable-column-advanced-sort-btn"
    />
    <p-button
      icon="pi pi-sort-amount-up-alt"
      [rounded]="true"
      [text]="true"
      *ngIf="sortOrder === 1"
      aria-hidden="true"
      styleClass="wl-prime-datatable-column-advanced-sort-btn"
    />
    <p-button
      icon="pi pi-sort-amount-down"
      [rounded]="true"
      [text]="true"
      *ngIf="sortOrder === -1"
      aria-hidden="true"
      styleClass="wl-prime-datatable-column-advanced-sort-btn"
    />
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'ReportName'" class="wl-prime-datatable-column-advanced-filter">
        <div class="wl-prime-datatable-column-advanced-filter-buttons">
          <p>
            {{ 'communications.mass-comm-message-admin.subscription.profile-name' | translate | titlecase }}
          </p>
          <p-sortIcon />
          <p-columnFilter
            type="text"
            field="ReportName"
            display="menu"
            [showMatchModes]="true"
            [matchModeOptions]="[{ label: 'Profile name has', value: 'contains' }]"
            [matchMode]="'contains'"
            [showOperator]="false"
            [showAddButton]="false"
            [showApplyButton]="true"
            [showClearButton]="false"
          >
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <input type="text" pInputText [(ngModel)]="searchParams.ProfileName" (change)="filter($event.value)" />
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th [pSortableColumn]="'Email'" class="wl-prime-datatable-column-advanced-filter">
        <div class="wl-prime-datatable-column-advanced-filter-buttons">
          <p>
            {{ 'communications.mass-comm-message-admin.subscription.email' | translate | titlecase }}
          </p>
          <p-sortIcon />
          <p-columnFilter
            type="text"
            field="Email"
            display="menu"
            [showMatchModes]="true"
            [matchModeOptions]="[{ label: 'Email has', value: 'contains' }]"
            [matchMode]="'contains'"
            [showOperator]="false"
            [showAddButton]="false"
            [showApplyButton]="true"
            [showClearButton]="false"
          >
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <input type="text" pInputText [(ngModel)]="searchParams.EmailAddress" (change)="filter($event.value)" />
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th [pSortableColumn]="'SubscriptionStatus'" class="wl-prime-datatable-column-advanced-filter">
        <div class="wl-prime-datatable-column-advanced-filter-buttons">
          <p>
            {{ 'communications.mass-comm-message-admin.subscription.status' | translate | titlecase }}
          </p>
          <p-sortIcon />
          <p-columnFilter
            type="dropdown"
            field="OptedIn"
            display="menu"
            [showMatchModes]="true"
            [matchModeOptions]="[{ label: 'Status is', value: 'contains' }]"
            [matchMode]="'contains'"
            [showOperator]="false"
            [showAddButton]="false"
            [showApplyButton]="true"
            [showClearButton]="true"
          >
            <ng-template pTemplate="filter" let-filter="filterCallback" let-clear="clearFilter">
              <div class="mct-flex mct-col mct-justify-between mct-items-stretch">
                <p-select
                  [(ngModel)]="searchParams.OptedIn"
                  [options]="statusDropDownOptions"
                  name="subscriptionStatus"
                  [placeholder]="'common.select' | translate | ucfirst"
                  (onChange)="filter($event.value)"
                ></p-select>
              </div>
            </ng-template>
          </p-columnFilter>
        </div>
      </th>
      <th [pSortableColumn]="'AuditDate'" class="wl-prime-datatable-column-advanced-filter">
        <div class="wl-prime-datatable-column-advanced-filter-buttons">
          <p>
            {{ 'communications.mass-comm-message-admin.subscription.date-changed' | translate | titlecase }}
          </p>
          <p-sortIcon />
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template let-subscriptionlog pTemplate="body">
    <tr>
      <td>
        <a (click)="navigateToProfile(subscriptionlog.ProfileId)">{{ subscriptionlog.ReportName }}</a>
      </td>
      <td>{{ subscriptionlog.Email }}</td>
      <td>{{ subscriptionlog.SubscriptionStatus }}</td>
      <td>{{ subscriptionlog.AuditDate | date: 'shortDate' }} {{ subscriptionlog.AuditDate | date: 'shortTime' }}</td>
    </tr>
  </ng-template>
</p-table>
